// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#rate[data-v-ce42351e]{background-color:#1b2445;box-sizing:border-box}#rate[data-v-ce42351e],#rate .box[data-v-ce42351e]{position:relative;width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
